import { runtimeConfig } from '@discovr/common/runtime-config';

/** The Help me write button needs a backend route that does not exist yet; off unless a build opts in. */
export const OUTREACH_HELP_ME_WRITE_ENABLED = runtimeConfig('OUTREACH_HELP_ME_WRITE') === 'true';
